import { render } from "./bill.component.vue?vue&type=template&id=38979f89&ts=true"
import script from "./bill.component.vue?vue&type=script&lang=ts"
export * from "./bill.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__